import {
  Box,
  Typography,
  Card,
  CardContent,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { FC } from "react";

interface NoticeItem {
  date: string;
  content: string;
}

interface NoticeSectionProps {
  notices: NoticeItem[];
}

export const NoticeSection: FC<NoticeSectionProps> = ({ notices }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Card
      sx={{
        mt: 2,
        mb: 2,
        bgcolor: "background.paper",
        boxShadow: 1,
        width: "100%",
        maxWidth: "478px",
        mx: "auto",
      }}
    >
      <CardContent sx={{ p: { xs: 2, md: 3 } }}>
        <Typography
          variant={isMobile ? "h6" : "h5"}
          component="h2"
          sx={{
            fontWeight: "bold",
            color: "primary.main",
            mb: 2,
            textAlign: "center",
          }}
        >
          お知らせ
        </Typography>

        <Box>
          {notices.map((notice, index) => (
            <Box key={index}>
              <Box sx={{ mb: 1 }}>
                <Typography
                  variant={isMobile ? "body2" : "body1"}
                  sx={{
                    fontWeight: "bold",
                    color: "text.secondary",
                    fontSize: isMobile ? "0.8rem" : "0.9rem",
                  }}
                >
                  {notice.date}
                </Typography>
                <Typography
                  variant={isMobile ? "body2" : "body1"}
                  sx={{
                    lineHeight: 1.6,
                    mt: 0.5,
                    wordBreak: "break-word",
                  }}
                >
                  {notice.content}
                </Typography>
              </Box>
              {index < notices.length - 1 && (
                <Divider sx={{ my: 1.5, borderColor: "grey.300" }} />
              )}
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};
